import React, {Component} from 'react';
import {connect} from 'react-redux';

class HTML extends Component {
  render() {
    if(this.props.inline) {
      return (
        <span dangerouslySetInnerHTML={{ __html:this.props.children }} />
      )
    }
    return (
      <div dangerouslySetInnerHTML={{ __html:this.props.children }} />
    )
  }
}


export default HTML;